import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  medicalList: []
}

const medicalSlice = createSlice({
  name: 'medical',
  initialState,
  reducers: {
    saveMedical: (state, action) => {
      state.medicalList.push(action.payload)
    },
    deleteAllMedical: (state, action) => {
      state.medicalList = [];
    },
  }
});

export const {
  saveMedical,
  deleteAllMedical
} = medicalSlice.actions

export const selectMedicalList = state => state.medical.medicalList

export default medicalSlice.reducer